module.exports = __webpack_public_path__ + "img/202005.38c721c1.png";